import {clientsClaim as workbox_core_clientsClaim} from '/var/www/html/wp-content/themes/pe-theme/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/var/www/html/wp-content/themes/pe-theme/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appassets/fonts/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "library/build/appassets/icons.af2ca511.svg",
    "revision": "e14e7f41fce3c6e227a5f62c5ef00cbc"
  },
  {
    "url": "library/build/appassets/img/pe-logo.ce3853e0.svg",
    "revision": null
  },
  {
    "url": "library/build/appassets/img/placeholder.8da8e659.svg",
    "revision": null
  },
  {
    "url": "library/build/appmain.4f31cf78.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.4f31cf78.js.LICENSE.txt",
    "revision": "928d21dfc5eb1f4e1131dadd8ef13f76"
  },
  {
    "url": "library/build/appmain.88375554.css",
    "revision": null
  },
  {
    "url": "library/build/apptemplates/cards/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "library/build/apptemplates/components/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "library/build/apptemplates/components/pagination.twig",
    "revision": "20594cedc726a975a93e162c61a32572"
  },
  {
    "url": "library/build/apptemplates/components/post-grid.twig",
    "revision": "2a52e0952df5ed307d17d19d05205535"
  },
  {
    "url": "library/build/apptemplates/elements/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  }
], {});








